import { useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { QRCodeSVG } from 'qrcode.react';

interface QrCodePixProps {
  chavePix: string;
  valor?: number;
  showValor?: boolean;
}

export default function QrCodePix({ chavePix, valor, showValor = true }: QrCodePixProps) {
  const toast = useRef<Toast>(null);

  const handleCopyChavePix = () => {
    if (chavePix) {
      navigator.clipboard.writeText(chavePix);
      toast.current?.show({
        severity: 'success',
        summary: 'Copiado!',
        detail: 'Chave PIX copiada para a área de transferência',
        life: 2000
      });
    }
  };

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  return (
    <div className="text-center">
      <Toast ref={toast} />
      
      {showValor && valor !== undefined && (
        <div className="mb-4">
          <p className="text-600 mb-2">Valor da compra:</p>
          <span className="text-2xl font-bold text-green-600">
            {formatCurrency(valor)}
          </span>
        </div>
      )}
      
      <div className="flex justify-content-center mb-4">
        <div className="bg-white p-3 border-round shadow-2 inline-block">
          <QRCodeSVG 
            value={chavePix} 
            size={250}
            level="H"
            includeMargin={true}
          />
        </div>
      </div>
      
      <div className="mb-4">
        <label className="font-semibold text-900 block mb-2">Chave PIX (Copia e Cola)</label>
        <div className="p-inputgroup">
          <InputText 
            value={chavePix} 
            readOnly
            className="font-mono text-sm"
          />
          <Button 
            icon="pi pi-copy" 
            onClick={handleCopyChavePix}
            tooltip="Copiar chave PIX"
            severity="secondary"
          />
        </div>
      </div>
      
      <div className="p-3 bg-blue-50 border-round border-1 border-blue-200">
        <div className="flex-consulta align-items-center gap-2 mb-2 justify-content-center">
          <i className="pi pi-info-circle text-blue-600"></i>
          <span className="text-blue-900 font-semibold">Instruções</span>
        </div>
        
        
        <div className="flex-consulta flex-column gap-2 text-left">
          <div className="flex-consulta align-items-center gap-2">
            <i className="pi  pi-stopwatch text-blue-600"></i>
            <span className="text-sm text-700">Chave pix válida por 20 minutos</span>
          </div>
          <div className="flex-consulta align-items-center gap-2">
            <i className="pi pi-mobile text-blue-600"></i>
            <span className="text-sm text-700">Abra o aplicativo do seu banco</span>
          </div>
          <div className="flex-consulta align-items-center gap-2">
            <i className="pi pi-qrcode text-blue-600"></i>
            <span className="text-sm text-700">Escaneie o QR Code acima</span>
          </div>
          <div className="flex-consulta align-items-center gap-2">
            <i className="pi pi-check text-blue-600"></i>
            <span className="text-sm text-700">Confirme o pagamento</span>
          </div>
          <div className="flex-consulta align-items-center gap-2">
            <i className="pi pi-clock text-blue-600"></i>
            <span className="text-sm text-700">O saldo será creditado em até 2 horas úteis</span>
          </div>
        </div>
      </div>
    </div>
  );
}
